import React, { FunctionComponent } from "react";
import {
  StepWrapper,
  Title,
  Paragraph,
} from "../styles/portal-agency-sign-up-styles";

const ThankYou: FunctionComponent<unknown> = () => (
  <StepWrapper data-test-id="thank-you-step" thankYou>
    <Title data-test-id="title">Almost there...</Title>
    <Paragraph centered data-test-id="paragraph">
      Please open your inbox and look out for an email from Hiring Hub asking
      you to set your password.
    </Paragraph>
  </StepWrapper>
);

export default ThankYou;
